import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDirectionUp = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 14",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.38388 7.88388C7.87204 7.39573 7.87204 6.60427 7.38388 6.11612L2.38388 1.11612C1.89573 0.627961 1.10427 0.627961 0.616117 1.11612C0.127961 1.60427 0.127961 2.39573 0.616116 2.88388L4.73223 7L0.616116 11.1161C0.127961 11.6043 0.127961 12.3957 0.616116 12.8839C1.10427 13.372 1.89573 13.372 2.38388 12.8839L7.38388 7.88388Z",
		fill: "var(--color, #2882DE)"
	})
});
export default SvgDirectionUp;
